import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import ReceiverImage from "../../../../../img/man-highlighted.png";
import SenderImage from "../../../../../img/man.png";
import Swal from "sweetalert2";
import Moment from "react-moment";
import { studySettingControlServices } from "../../../../../Services/studyServices/studySettingControlServices";
import { cdiscServices } from "../../../../../Services/CDISC/cdiscServices";

const StudySiteQueryDiscussionComponent = ({
  isFullScreen,
  setStatus,
  getBackgroundColor,
  status,
  queryId,
  getDataEntryQueryList,
  queryGenerator,
  currentUserId,
  subjectId,
  templateId,
  studyId,
  getStudyDataTemplates,
}) => {
  const [discussionList, setDiscussionList] = useState([]);
  const [responseList, setResponseList] = useState([]);
  const [message, setMessage] = useState("");
  const [customMessage, setCustomMessage] = useState("");
  const updateCDISCSDataEntryQueryStatus = async (status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to update Query Ticket Status?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.templateId = templateId;
        userData.status = status;
        userData.studyId = studyId;
        userData.queryId = queryId;
        let data = await cdiscServices.updateCDISCSDataEntryQueryStatus(
          userData
        );
        if (data.statusCode === 200) {
          getDataEntryQueryList();
          getStudyDataTemplates();
        }
      }
    });
  };

  const getDataEntryQueryDiscussionList = async () => {
    let data = await cdiscServices.getDataEntryQueryDiscussionList(
      studyId,
      queryId
    );
    setDiscussionList(data?.data);
  };

  const sendCDISCDataEntryQueryDiscussion = async () => {
    let userData = {};
    userData.studyId = studyId;
    userData.queryId = queryId;
    userData.message = message;
    userData.templateId = templateId;
    userData.type = queryGenerator === currentUserId ? "sender" : "receiver";
    let data = await cdiscServices.sendCDISCDataEntryQueryDiscussion(
      userData
    );
    if (data?.statusCode === 200) {
      getDataEntryQueryDiscussionList(queryId);
      setMessage("");
      setCustomMessage("");
      getDataEntryQueryList();
    }
  };

  const getActiveQueryResponseMessageList = async () => {
    let data =
      await studySettingControlServices.getActiveQueryResponseMessageList(
        subjectId
      );
    setResponseList(data?.data);
  };

  useEffect(() => {
    getDataEntryQueryDiscussionList();
  }, [queryId]);

  useEffect(() => {
    getActiveQueryResponseMessageList();
  }, [subjectId]);

  return (
    <>
      <div
        className={`position-relative ${
          isFullScreen ? "pdf_viwer_section_full" : ""
        }`}
      >
        <div
          className="hstack justify-content-between border-bottom p-1 position-sticky top-0"
          style={{ background: "#b8cfdf" }}
        >
          <span>
            <b>#{queryId}</b>{" "}
            <i
              className="fa-solid fa-rotate text-white rounded-circle p-1"
              title="Refresh Query Discussion"
              onClick={() => getDataEntryQueryDiscussionList(queryId)}
              style={{
                backgroundColor: "#103c5e",
                fontSize: 8,
              }}
            ></i>
          </span>
          <div className="hstack gap-2 text-nowrap">
            <span style={{ fontSize: 10 }}>
              <b>Status :</b>{" "}
            </span>
            <Form.Select
              className="  border-0"
              value={status}
              disabled={status === "cancel"}
              onChange={(e) => {
                setStatus(e.target.value);
                updateCDISCSDataEntryQueryStatus(e.target.value);
              }}
              style={{
                backgroundColor: getBackgroundColor(status),
                fontSize: 11,
                padding: "2px 32px 2px 8px",
              }}
            >
              <option selected={status === "open"} value="open">
                Open
              </option>
              {!(status === "closed") && (
                <option selected={status === "inprogress"} value="inprogress">
                  In Progress
                </option>
              )}
              {!(status === "closed" || status === "inprogress") && (
                <option selected={status === "cancel"} value="cancel">
                  Cancel
                </option>
              )}
              <option selected={status === "closed"} value="closed">
                Closed
              </option>
            </Form.Select>
          </div>
        </div>
        <div
          className={`chat ${isFullScreen ? "chatFullHeight" : "chatHeight"}`}
        >
          {discussionList?.map((item, index) => (
            <div key={index}>
              {!(item.messageByuserId === queryGenerator) ? (
                <div className="receiverSays">
                  <div className="text-box-receiver">
                    <div className="text">
                      <div className="d-flex gap-2 mb-3">
                        <img
                          src={ReceiverImage}
                          alt="Receiver Img"
                          title={`Sender Name: ${item.messageBy} \nSender Id: ${item.messageuserIdBy}`}
                        />
                        <div style={{ lineHeight: "15px" }}>
                          <p>{item.message}</p>
                          <span>
                            <Moment format="DD MMM YYYY | HH:mm:ss">
                              {item.createdAt}
                            </Moment>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="userSays">
                  <div className="text">
                    <div className="d-flex gap-2 mb-3">
                      <div style={{ lineHeight: "15px" }}>
                        <p>{item.message}</p>
                        <span>
                          <Moment format="DD MMM YYYY | HH:mm:ss">
                            {item.createdAt}
                          </Moment>
                        </span>
                      </div>
                      <img
                        src={SenderImage}
                        alt="Sender Img"
                        title={`Receiver Name: ${item.messageBy} \nReceiver Id: ${item.messageuserIdBy}`}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div
          className="border-top border-bottom position-sticky bg-light"
          style={{ bottom: 25 }}
        >
          <div className="hstack p-1 gap-2">
            {!customMessage && (
              <Form.Select
                disabled={status === "closed" || status === "cancel"}
                onChange={(e) => {
                  setMessage(e.target.value);
                  setCustomMessage(e.target[e.target.selectedIndex].title);
                }}
              >
                <option value="">
                  {status === "open"
                    ? "Select Message Suggestion"
                    : status === "closed"
                    ? "Query has been Closed"
                    : "Query has been Cancelled"}
                </option>
                <option
                  value=""
                  title="customMessage"
                  className="bg-secondary text-white"
                >
                  Custom Message
                </option>
                {responseList?.map((data, index) => (
                  <option key={index} value={data.response}>
                    {data.response}
                  </option>
                ))}
              </Form.Select>
            )}

            {customMessage === "customMessage" && (
              <Form.Control
                 
                type="text"
                value={
                  status === "open"
                    ? message
                    : status === "closed"
                    ? "Query has been Closed"
                    : "Query has been Cancelled"
                }
                disabled={status === "closed" || status === "cancel"}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type query...."
              />
            )}
            <button
              disabled={
                !message && (status === "closed" || status === "cancel")
              }
              onClick={sendCDISCDataEntryQueryDiscussion}
              className="updateProfile"
              style={{ padding: "5px 10px" }}
            >
              <i className="fa-regular fa-paper-plane"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudySiteQueryDiscussionComponent;
